import * as d3 from "d3";
export default (function(){

    var sideMargin = 10;
    var barHeight = 30;
    var labelYOffset = 10;
    var labelMinGap = 5;
    var labelFont = '10px Arial';

    var getWidth = (function(){
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');
        context.font = labelFont;
        return function(text) {
            return context.measureText(text).width;
        }
    })();

    function hasLabels(data) {
        return data.reduce((all, item) => {
            return all || item.label;
        }, false);
    }

    function layoutLabels(data, scale) {
        var accVal = 0;
        var labelsData = data
            .map(function(d){
                var w = getWidth(d.label);
                var barx = scale(accVal + d.value / 2);
                var x = barx - w / 2;
                accVal += d.value;
                return {
                    x: x,
                    barx: barx,
                    w: w,
                    label: d.label,
                    cls: d.cls
                };
            });
        //push right to left on collision
        var nextLabelMaxX = scale.range()[1];
        for (let i = labelsData.length - 1; i >= 0; i--) {
            let d = labelsData[i];
            if (nextLabelMaxX < (d.x + d.w)) {
                d.x = nextLabelMaxX - d.w;
            }
            nextLabelMaxX = d.x - labelMinGap;
        }

        //push left to right on collision
        var nextLabelMinX = scale.range()[0];
        for (let i = 0; i < labelsData.length; i++) {
            let d = labelsData[i];
            if (nextLabelMinX > d.x) {
                d.x = nextLabelMinX;
            }
            nextLabelMinX = d.x + d.w + labelMinGap;
        }
    
        return labelsData;
    }

    /**
     *
     * data := [
     *      stack1,
     *      stack2,
     *      ...
     * ];
     *
     * stack := {
     *  cls,
     *  label,
     *  value
     * }
     *
     */
    function bc(svgId, data, max) {
        var svg = d3.select('#' + svgId);
        var allEmpty = data.reduce(function(a,b){
            return a && !b.value;
        }, true);
        var erronous = data.reduce(function(a, b){
            return a || b.value < 0;
        }, false);
        if (allEmpty || erronous) {
            svg.selectAll('g')
                .transition()
                .style('opacity', 0)
                .remove();
            return;
        } else {
            if (!svg.select('g.chart-cnt').size()) {
                svg.attr('transform', 'scale(1,0)')
                    .transition()
                    .attr('transform', 'scale(1,1)')
                    .style('opacity', 1);
            }
            //svg.transition().style('height', 60 /*+ 20 * data.length*/ + 'px');
        }
        if (!max)
            max = data[0].value + data[1].value;
        var stack = d3.stack()
            .keys(d3.range(data.length))
            .value(function(d, key){
                return d[key].value;
            })([data]);
        var rectData = data.map(function(d, i){
            return {
                cls: d.cls,
                x1: stack[i][0][0], //itosios serijos, pirmas pointas (tik vienas tegali buti)
                x2: stack[i][0][1]
            };
        });
        var svgWidth = svg.node().getBoundingClientRect().width;
        var scale = d3.scaleLinear()
            .domain([0, max])
            .range([sideMargin, svgWidth - 2*sideMargin]);

        if (!svg.select('g.chart-cnt').size()) {
            svg.append('g')
                .classed('legend', true);
            svg.append('g')
                .classed('labels', true);
            svg.append('g')
                .classed('chart-cnt', true)
        }

        if (hasLabels(data)) {
            svg.attr('height', barHeight + labelYOffset + 20 + 'px')
        } else {
            svg.attr('height', barHeight + 'px');
        }

        var rects = svg.select('g.chart-cnt')
            .selectAll('rect')
            .data(rectData, function(d) {return d.cls;});

        rects.enter()
            .append('rect')
            .attr('y', 0)
            .attr('height', barHeight)
            .attr('x', function(d){return scale(d.x1)})
            .attr('class', function(d){return d.cls;})
            .attr('width', function(d){return Math.max(0, scale(d.x2) - scale(d.x1));});
        rects
            .transition()
            .attr('x', function(d){return scale(d.x1)})
            .attr('width', function(d){return Math.max(0, scale(d.x2) - scale(d.x1));});

        rects.exit().remove();


        var labelsData = layoutLabels(data, scale);

        var labels = svg.select('g.labels')
            .selectAll('g.label')
            .data(labelsData, function(d) { return d.cls; });

        labels.exit().remove();

        var labelsEnter = labels.enter().append('g').attr('class', function(d){ return d.cls; }).classed('label', true);
        labelsEnter.append('line')
            .attr('x1', function(d) { return d.x + d.w / 2; })
            .attr('y1', barHeight + labelYOffset)
            .attr('x2', function(d) { return d.barx; })
            .attr('y2', barHeight);

        labelsEnter.append('text')
            .attr('x', function(d) { return d.x; })
            .attr('y', barHeight + labelYOffset)
            .style('font', labelFont)
            .text(function(d) { return d.label; });

        labels = labels.merge(labelsEnter);
        labels.select('line')
            .transition()
            .attr('x1', function(d) { return d.x + d.w / 2; })
            .attr('x2', function(d) { return d.barx; });
        labels.select('text')
            .transition()
            .attr('x', function(d) { return d.x; });
            
    }


    return bc;
}());
